<template>
  <Allow
      title="Необходимо подписаться на оповещения"
      content="С помощью оповещений организатор сможет выставить вам счета по закупкам,
      сообщить о приходе или наличии товара, а также сообщить о распродажах и конкурсах сообщества"
      @action="action"
  ></Allow>
</template>

<script>
import Allow from '@/components/Allow'
import {messGet} from '@/services/vkApi'

export default {
  name: 'AllowSubscription',
  components: {Allow},
  methods: {
    action: messGet
  }
}
</script>

<style scoped>

</style>